import { render, staticRenderFns } from "./ProductRequest.vue?vue&type=template&id=df85d2ec&"
import script from "./ProductRequest.vue?vue&type=script&lang=js&"
export * from "./ProductRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports